import {readable, writable, derived} from 'svelte/store';
import firebase from 'firebase';
import _ from 'lodash';
import {firebaseUser} from "../auth/authStore";
import {persistStorage} from "../lib/persistStorage";
import {persistWritable} from "../lib/store";

export const myChannels = derived(firebaseUser, ($firebaseUser, set) => {
  set(null);
  if (!$firebaseUser) return () => {};

  return firebase.firestore().collection('channels').where('userId', '==', $firebaseUser.uid).onSnapshot(snapshot => {
    set(_.keyBy(snapshot.docs, 'id'));
  });

});

export const selectedChannelId = persistWritable('selectedChannelId', null);

export const selectChannel = channel => {
  selectedChannelId.set(_.get(channel, 'id', null));
};

// {id: true}
let _unlockedChannels = {};
export const unlockedChannels = writable(_unlockedChannels);
unlockedChannels.subscribe(val => _unlockedChannels = val);

window.addEventListener('blur', () => unlockedChannels.set({}));

export const unlockChannel = channelId => {
  unlockedChannels.set({
    ..._unlockedChannels,
    [channelId]: true
  });
};

export const updateChannel = (id, data) => {
  return firebase.firestore().collection('channels').doc(id).update({
    ...data,
    modified: firebase.firestore.FieldValue.serverTimestamp()
  });
};

export const deleteChannel = id => {
  const promise = firebase.firestore().collection('channels').doc(id).delete();
  selectChannel(null);

  return promise;
};